import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { omit } from 'underscore';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import cx from 'classnames';

// components
import Paginator from '../../components/paginator/paginator';

// ducks
import { paginateThis, sortFields } from '../../ducks/AssistedLivingSearch';

// middleware
import { cleanQuery } from '../../middleware/client';

// containers
import AssistedLivingSearchResults from './AssistedLivingSearchResults';
import AssistedLivingSearchForm from './AssistedLivingSearchForm';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

class AssistedLivingSearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    const {
      query,
      location: { pathname }
    } = this.props;
    const { handleChange, handleSubmit } = this;
    const initialValues = omit(query, 'page', 'pageSize');
    const linkQuery = cleanQuery(query);

    return (
      <Container fluid className={styles.AssistedLivingSearch}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to={this.props.pathname}>
                <BreadcrumbItem active>Assisted Living Search</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <AssistedLivingSearchForm
          enableReinitialize={true}
          initialValues={initialValues}
          onFilterClick={() => {
            this.setState({
              showModal: true
            });
          }}
          onChange={handleChange}
          onSubmit={handleSubmit}
          basePath={pathname}
        />

        <Row className={cx(styles.searchPagination, BS.pt3)}>
          <Container>
            <Paginator
              listId="assisted-living"
              to={pathname}
              query={linkQuery}
              sortFields={sortFields}
              top
            />
          </Container>
        </Row>
        <AssistedLivingSearchResults listId="assisted-living" />
        <Row className={cx(styles.searchPagination, BS.pt3)}>
          <Container>
            <Paginator
              listId="assisted-living"
              to={pathname}
              query={linkQuery}
              sortFields={sortFields}
              bottom
            />
          </Container>
        </Row>
      </Container>
    );
  }

  handleChange(values, dispatch, props, previousValues) {
    clearTimeout(this.onChangeSubmitTimeout);
    if (!props.pristine) {
      this.onChangeSubmitTimeout = setTimeout(() => {
        props.submit();
      }, 100);
    }
  }

  handleSubmit(values, dispatch, props) {
    const {
      submitSearch,
      location: { pathname }
    } = this.props;

    return submitSearch({
      to: pathname,
      values: values
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.query.page !== prevProps.query.page) {
      window.scrollTo(0, 0);
    }
  }
}

const AssistedLivingSearchDecorated = paginateThis.decorate(
  AssistedLivingSearch,
  (state, props) => {
    return {
      name: ''
    };
  }
);

AssistedLivingSearchDecorated.defaultProps = {
  pathname: '/assisted-living'
};

export default AssistedLivingSearchDecorated;



// WEBPACK FOOTER //
// ./src/containers/AssistedLivingSearch/AssistedLivingSearch.js